import React, { memo } from 'react';
import { CheckmarkIcon, colors } from '@chegg-ui/theme';
import { hasMinLength, hasSpecialChars, hasUpperAndLowercase } from "../../utils/passwordValidations";
import { PasswordRulesList, PasswordRule, CheckmarkContainer } from "./Signup.styles";
import { getTexts } from "../../lib/contentful/defaultTexts";
var PasswordRules = function PasswordRules(_ref) {
  var password = _ref.password;
  var _getTexts = getTexts(),
    _getTexts$signup = _getTexts.signup,
    passwordValidationMinLength = _getTexts$signup.passwordValidationMinLength,
    passwordValidationCaseSensitive = _getTexts$signup.passwordValidationCaseSensitive,
    passwordValidationSpecialChars = _getTexts$signup.passwordValidationSpecialChars;
  var items = [{
    valid: hasMinLength(password, 6),
    text: passwordValidationMinLength
  }, {
    valid: hasUpperAndLowercase(password),
    text: passwordValidationCaseSensitive
  }, {
    valid: hasSpecialChars(password),
    text: passwordValidationSpecialChars
  }];
  return /*#__PURE__*/React.createElement(PasswordRulesList, {
    "data-test": "password_rules"
  }, items.map(function (_ref2, index) {
    var valid = _ref2.valid,
      text = _ref2.text;
    return /*#__PURE__*/React.createElement(PasswordRule, {
      key: index
    }, /*#__PURE__*/React.createElement(CheckmarkContainer, null, valid && /*#__PURE__*/React.createElement(CheckmarkIcon, {
      size: "xsmall",
      iconFill: "circlefill",
      svgColor: colors.green700,
      "data-test": "valid_checkmark"
    }) || /*#__PURE__*/React.createElement("span", {
      className: "bullet"
    })), text);
  }));
};
export default /*#__PURE__*/memo(PasswordRules);